import { render, staticRenderFns } from "./accessory.vue?vue&type=template&id=e664f3d0&"
import script from "./accessory.vue?vue&type=script&lang=js&"
export * from "./accessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports